import apiClient from '../apiClient';
import { POST_SET_PRIMARY_IMAGE_ACCOMODATION_ITEM_URL } from '../apiUrl';

const postSetPrimaryImageAccomodationItemApi = (id, data) => {
  return apiClient.post(POST_SET_PRIMARY_IMAGE_ACCOMODATION_ITEM_URL(id), data);
};

export default postSetPrimaryImageAccomodationItemApi;
